import React, {
    useContext,
    useEffect,
    useState
} from 'react'
import {
    Autocomplete,
    Backdrop, Box, Button,
    Card,
    Container, Divider,
    Grid, InputAdornment,
    Skeleton,
    Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, TextField, Tooltip, Typography,
} from '@mui/material'
import { api } from '../../../services/Main/Api'
import {
    CurrencyExchange,
    QrCode,
    Receipt, Search,
} from '@mui/icons-material'
import CardInvoiceInfo from '../../../components/Invoice/CardInvoiceInfo'
import {
    getCondoId, getCondoType,
    getFilterDate, getNotBank,
    setFilterDate
} from '../../../services/Main/AuthStorage'
import { useSnackbar } from 'notistack'
import ModalForm from '../../../components/Modal/ModalForm'
import moment from 'moment'
import UnitFilter from '../../../components/Filters/UnitFilter'
import ReferenceMonthFilter from '../../../components/Filters/ReferenceMonthFilter'
import StatusTabFilter from '../../../components/Filters/StatusTabsFilter'
import { Helmet } from 'react-helmet'
import CircularProgress from '@mui/material/CircularProgress'
import Context from '../../../contexts/Context'
import TableInvoiceHead from "./components/InvoiceList/TableInvoiceHead";
import TableInvoiceBody from "./components/InvoiceList/TableInvoiceBody";
import NoResultsAnimation from "../../../components/Shared/animations/NoResultsAnimation";
import GenerateCharge from "./components/InvoiceList/GenerateCharge";

import PaginationGlobal from "../../../components/Shared/PaginationGlobal";

import {DesktopDatePicker, MobileDatePicker} from "@mui/x-date-pickers";
import DateRangeLite from "../../../components/DateRangeLite/DataRangeLite";
import InvoiceIcon from "../../../components/Invoice/InvoiceIcon";
import StatusInvoice from "../../../components/Invoice/StatusInvoice";
import masks from "../../../components/Shared/Masks";
import Masks from "../../../components/Shared/Masks";


const InvoiceCashFlow = () => {
    const [response, setResponse] = useState(null)
    const {user, invoiceListRefresh, setInvoiceListRefresh} = useContext(Context)

    const [chargeReq, setChargeReq] = useState(
        {
            condo: +getCondoId(),
            month: moment.utc(new Date()).format(),
            year: moment.utc(new Date()).format('YYYY'),
            due_date: moment.utc().add(1, 'day').format('YYYY-MM-DD'),
            send_email: true,
            send_whatsapp: false
        }
    )

    const storageDate = getFilterDate()
    const { enqueueSnackbar } = useSnackbar()

    const [summary, setSummary] = useState(true)
    const [openForm, setOpenForm] = useState(false)
    const [unitOptions, setUnitOptions] = useState([{ label: 'The Godfather', id: 1 },
        { label: 'Pulp Fiction', id: 2 },
    ])
    const [status, setStatus] = useState(null)
    const [unit, setUnit] = useState(null)
    const [isPaid, setIsPaid] = useState(false)
    const [loadingModal, setLoadingModal ] = useState(false)
    const [errors, setErrors] = useState(null)
    const [search, setSearch] = useState(null)
    const [month, setMonth] = useState(moment(new Date(storageDate)).format("MM"))
    const [year, setYear] = useState(moment(new Date(storageDate)).format("YYYY"))
    const {filters, setFilters } = useContext(Context)
    const [openByStatus, setOpenByStatus] = useState({paid: false, remake: false, create: false, open: false, deleted: false})

    const monthFormat = +moment(storageDate).format("MM")
    const yearFormat = +moment(storageDate).format("YYYY")
    const reference = response?.results && response?.results.length > 0 ?
        response?.results[0].reference_mode_company.value : null;
    const { perm_bank } = user || {}

    function handleStatusFilter (e, value){

        if (value === 'all'){
            setStatus(null)
        }else{
            setStatus(value)
        }
    }

    function handleManualPayment (){
        setIsPaid(true);
        setLoadingModal(true)
    }

    const handleCreateSlip = () => {
        const data = {
            ...chargeReq,
            month: +moment.utc(chargeReq?.month).format('MM'),
            year: +chargeReq?.year
        }

        api.post('bank-slip/billing-month/', data)
            .then(response => {
                if (response?.status === 201) {
                    enqueueSnackbar(response?.data.success, { variant: 'success' })
                    setOpenForm(false)
                }
            })
            .catch(response => {
                setErrors(response?.response.data)
            })
    }


    useEffect(function invoiceSummary(){
        const condo = getCondoId()

        const summaryData = {
            condo: +condo,
            due_date__gte: filters.startDate,
            due_date__lte: filters.endDate,
        }

        api.post(`analytics/invoice-summary/`, summaryData)
            .then(response => {
                const data = response.data
                setSummary(data)
            }).catch(error => {
        })

    }, [response])


    useEffect(()=>{
        setFilters({
            unit__condo_id: getCondoId(),
            page_size: 50,
            startDate: moment().startOf("month").format("YYYY-MM-DD"),
            endDate:  moment().endOf("month").format("YYYY-MM-DD")
        })
    },[])


    function getInvoices() {

        const params = {
            due_date__gte: filters.startDate,
            due_date__lte: filters.endDate,
            page_size:filters.page_size,
            page: filters.page,
            unit__condo_id: getCondoId(),
            ordering: filters.ordering,
        }

        if (status){
            params.status = status;
        }

        if (unit){
            params.unit_id = unit?.id;
        }

        if (search){
            params.search = search;
        }

        if (params.due_date__lte && params.due_date__gte) {
            api.get(`invoice/`, {params})
                .then(response => {
                    const data = response.data
                    setResponse(data)
                    setIsPaid(false)
                    setTimeout(() => {
                        setLoadingModal(false);
                    }, 1000);
                }).catch(error => {
                console.log(error)
            }).finally(() => {
                setInvoiceListRefresh(false)
            })
        }
    }
    useEffect(()=>{
        getInvoices()
        window.scrollTo(0, 0);
    }, [filters, isPaid, status, search])


    useEffect(() => {
        if (invoiceListRefresh === true) {
            getInvoices();
        }
    }, [invoiceListRefresh]);
    let typingTimer = ""


    const handleRangeChange = (range) => {
        // range.start / range.end = objetos moment
        // range.startISO / range.endISO = strings YYYY-MM-DD (ótimo p/ API)
        // exemplo: atualizar filtros de listagem
        setFilters(prev => ({ ...prev, startDate: range.startISO, endDate: range.endISO }));
        console.log("range:", range);
    };
    return (
        <>
            <Helmet>
                <title>Recebimentos - Bloco B3</title>
            </Helmet>
            <Backdrop
                sx={{ color: '#fff', zIndex: 1500, }}
                open={loadingModal}
            >
                <CircularProgress color="inherit"/>
            </Backdrop>
            <Container maxWidth={false}>
                <Box
                    sx={{
                        display: 'flex',
                        '@media (max-width:600px)': {
                            display: 'grid',
                            gridTemplateColumns: 'repeat(1, 1fr)',
                            gap: 3,
                        },
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        mb: 3,

                    }}
                >
                    <Typography
                        textAlign={'center'}
                        variant={'h5'}
                    >
                        Recebimentos
                    </Typography>
                    <Box
                        sx={{
                            '@media (max-width:600px)': {
                                display: 'grid',
                                gridTemplateColumns: 'repeat(1, 1fr)',
                                gap: 2,

                            }
                        }}
                    >
                        {getCondoType() === 'CONDO' && perm_bank === true  &&
                            <Tooltip title="Gera boletos com faturas em aberto">
                                <Button
                                    startIcon={<CurrencyExchange />}
                                    variant={'contained'}
                                    size={'small'}
                                    onClick={() => setOpenForm(true)}
                                    sx={{
                                        ml: '1rem',
                                        '@media (max-width:600px)': {
                                            ml: 0,
                                        }
                                    }}
                                >
                                    Gerar Boletos
                                </Button> </Tooltip>}

                    </Box>

                </Box>

                <>
                    {/*<CardInvoiceInfo date={storageDate}/>*/}
                </>
                <Card>
                    {response?.results ?
                        <>

                            <Grid container sx={{ p: 2, alignItems: 'center', justifyContent:"start" }} spacing={1}>
                                <Grid item xs={12} sm={12} lg={12} sx={{display: "flex", justifyContent: "start"}}>
                                    <StatusTabFilter
                                        onChange={handleStatusFilter}
                                        summary={summary}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4} lg={4}>
                                    <TextField id="outlined-basic" label="Buscar" variant="outlined"
                                               sx={{marginRight: ".5rem", width: "100%"}}
                                               onKeyUp={(event) => {
                                                   clearTimeout(typingTimer);
                                                   typingTimer = setTimeout(() => setSearch(event.target.value), 1000);
                                               }}
                                               size={'small'}
                                               InputProps={{
                                                   endAdornment: <InputAdornment position="end"><Search/></InputAdornment>,
                                               }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} lg={6} sx={{textAlign: "left"}}>
                                    <DateRangeLite
                                        // initialStart={filters?.startDate}
                                        // initialEnd={filters?.endDate}
                                        disablePast={false}
                                        onChangeRange={handleRangeChange}
                                    />
                                </Grid>
                                {/*<Grid item xs={12} sm={6} lg={6} sx={{textAlign: "left"}}>*/}
                                {/*  <DesktopDatePicker*/}
                                {/*    openTo="month"*/}
                                {/*    views={['year', 'month']}*/}
                                {/*    label="Mês de Pagamento"*/}
                                {/*    inputProps={{ readOnly: true }}*/}
                                {/*    disableMaskedInput*/}
                                {/*    value={moment(`${month}-${year}`, 'MM-YYYY').toDate()}  // Passe o objeto Date diretamente*/}
                                {/*    onChange={(newValue) => {*/}
                                {/*      setMonth(moment(new Date(newValue)).format("MM"))*/}
                                {/*      setYear(moment(new Date(newValue)).format("YYYY"))*/}
                                {/*      console.log(newValue)*/}
                                {/*      setFilterDate(moment(newValue, 'MM-YYYY').toISOString())*/}
                                {/*    }}*/}
                                {/*    slotProps={{*/}
                                {/*      textField: {*/}
                                {/*        size: "small",*/}
                                {/*        inputProps: { readOnly: true },*/}
                                {/*      },*/}
                                {/*    }}*/}
                                {/*  />*/}
                                {/*</Grid>*/}


                            </Grid>
                            <Divider/>
                            <TableContainer>
                                {response?.results?.length > 0  ?
                                    <Table>
                                        {/*<TableInvoiceHead*/}
                                        {/*    reference={reference}*/}
                                        {/*/>*/}
                                        <TableHead>
                                            <TableRow>

                                                <TableCell sx={{  color: 'primary.main'}}>Cliente</TableCell>
                                                <TableCell sx={{  color: 'primary.main'}}>Vencimento</TableCell>
                                                <TableCell sx={{  color: 'primary.main'}} align={"center"}>Status</TableCell>
                                                <TableCell sx={{  color: 'primary.main'}} align={"center"}>Valor</TableCell>

                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {response?.results?.map(object =>
                                                <TableRow
                                                    key={object.number}
                                                    hover
                                                    onClick={(e) => {
                                                        e.stopPropagation()
                                                        navigate(`/faturas/${object.id}`)
                                                    }}
                                                    sx={{ 'cursor': 'pointer', }}
                                                >
                                                    <TableCell>
                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                alignItems: 'center'
                                                            }}
                                                        >
                                                            <InvoiceIcon
                                                                variant={object?.status.key}
                                                                key={object.id}
                                                            />
                                                            {object.name}
                                                        </Box>
                                                    </TableCell>
                                                    <TableCell>
                                                        {moment(object.due_date).format("DD/MM/YYYY")}
                                                    </TableCell>
                                                    <TableCell>
                                                        <StatusInvoice
                                                            invoice={object}
                                                            paidAt={object?.paid_at}
                                                        />
                                                    </TableCell>
                                                    <TableCell sx={{  fontWeight: 'bold' }} align={"center"}>
                                                        {object?.total_paid > 0 ?  `${Masks.money(object?.total_paid.toString())}` : `${Masks.money(object?.total.toString())}`}
                                                    </TableCell>
                                                </TableRow> )}
                                                </TableBody>

                                    </Table>
                                    :
                                    <NoResultsAnimation />
                                }
                            </TableContainer>
                        </>
                        :
                        <Skeleton
                            variant="rounded"
                            height={700}
                            animation="pulse"
                        />
                    }
                </Card>
                <ModalForm
                    id="model-invoice-form"
                    keepMounted
                    title={'Gerar Boletos'}
                    open={openForm}
                    onClose={() => setOpenForm(false)}
                    errors={errors}
                    callback={handleCreateSlip}
                >
                    <GenerateCharge
                        chargeReq={chargeReq}
                        setChargeReq={setChargeReq}
                        errors={errors}
                        setErrors={setErrors}
                    />

                </ModalForm>
            </Container>
            {response?.count > 0 &&
                <PaginationGlobal
                    state={response}
                    filters={filters}
                    setFilters={setFilters}
                />
            }
        </>
    )
}

export default InvoiceCashFlow
